<template>
<div>
  <div class="d-flex" id="wrapper">
    <SideBar />
    <div id="page-content-wrapper">
      <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
        <div>
          <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
          </button>

          <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
          </button>
        </div>
        <div class="d-flex">
          <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
          <p class="text-muted mb-0 hover-cursor link" @click="$toCatalogProduct($router)">&nbsp;Catalog / Product</p>
          <p class="text-muted mb-0 hover-cursor link" @click="toPage('/catalog/bom/' + $route.params.id + '?unit=' + isUnit)">&nbsp; / BOM</p>
          <p class="text-primary mb-0 hover-cursor">&nbsp;/&nbsp;Add</p>
        </div>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ admin }}
              </a>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
              </div>
            </li>
          </ul>
        </div>
      </nav>
      <div class="container-fluid">
        <div class="container">
          <div class="row justify-content-center">
            <h4 class="py-3 my-3 m-auto">Add BOM</h4>
          </div>
          <h6 class="mt-3 mb-4" style="font-weight: bold">{{productTitle}}</h6>
          <div class="col-lg-12 px-0">
            <div class="d-flex align-items-center mt-2">
              <div class="col-1 pl-0">
                <span class="field-label"> Type </span>
              </div>
              <div class="col-11 pr-0">
                <select name="select-bom-type" id="bomType" class="form-control form-control-md" v-model="bomType" disabled>
                  <option value="1">Single</option>
                  <option value="2">Generate Combination</option>
                </select>
              </div>
            </div>
            <div class="d-flex align-items-center mt-2" v-if="productType == 'CPU'">
              <div class="col-1 pl-0">
                <span class="field-label"> Casing </span>
              </div>
              <div class="col-11 pr-0">
                <multiselect v-model="selectCase" :options="caseSku" label="itemName" :allow-empty="false" :select-label="'Type'" :deselect-label="''" placeholder="Select Item" track-by="itemName"></multiselect>
              </div>
            </div>
            <div class="d-flex align-items-center mt-2" v-if="productType == 'CPU'">
              <div class="col-1 pl-0">
                <span class="field-label"> Motherboard </span>
              </div>
              <div class="col-11 pr-0">
                <multiselect v-model="selectMotherboard" :options="motherboardSku" label="itemName" :allow-empty="false" :select-label="'Type'" :deselect-label="''" placeholder="Select Item" track-by="itemName"></multiselect>
              </div>
            </div>
            <div class="d-flex align-items-center mt-2">
              <div class="col-1 pl-0">
                <span class="field-label" v-if="productType == 'Laptop'"> Body </span>
                <span class="field-label" v-if="productType == 'CPU'"> Processor </span>
              </div>
              <div class="col-11 pr-0" v-if="processorSku">
                <!-- :disabled="disableBody && (onboardRamSize == null && onboardSSDSize == null || selectProcessor.itemCode)" -->
                <multiselect v-model="selectProcessor" :options="processorSku" @input="handleChangeProcessor" label="itemName" :allow-empty="false" :select-label="'Type'" :deselect-label="''" placeholder="Select Item" track-by="itemName"></multiselect>
              </div>
            </div>
            <!-- FIELD RAM -->
            <div v-if="validateRAMField">
              <div class="d-flex align-items-center mt-2" v-for="(data,i) in selectRam" :key="'ram-' + i+1">
                <div class="col-1 pl-0">
                  <span v-if="i == 0" class="field-label"> RAM </span>
                  <span v-else class="field-label"> RAM - {{i+1}} </span>
                </div>
                <div class="col-lg-11 pr-0">
                  <div class="container px-0">
                    <div class="d-flex">
                      <div class="w-100 pr-1">
                        <multiselect v-model="selectRam[i]" :options="ramSku" label="itemName" :allow-empty="false" :select-label="'Type'" :deselect-label="''" placeholder="Select Item" track-by="itemName"></multiselect>
                      </div>
                      <button v-if="i == 0" type="button" class="btn btn-sm btn-primary" style="width: 30px" @click="addRam">+</button>
                      <button v-else-if="i > 0" type="button" class="btn btn-sm btn-primary" style="width: 30px" @click="deleteRam(i)">-</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- FIELD SSD -->
            <div v-if="validateSSDField">
              <div  v-for="(data,i) in selectSSD" :key="'ram-' + i+1" class="d-flex align-items-center mt-2" >
                <div class="col-1 pl-0">
                  <span v-if="i == 0" class="field-label"> SSD </span>
                  <span v-else class="field-label"> SSD - {{i+1}} </span>
                </div>
                <div class="col-lg-11 pr-0">
                  <div class="container px-0">
                    <div class="d-flex">
                      <div class="w-100 pr-1">
                        <multiselect v-model="selectSSD[i]" :options="ssdSku" label="itemName" :allow-empty="false" :select-label="'Type'" :deselect-label="''" placeholder="Select Item" track-by="itemName"></multiselect>
                      </div>
                      <button v-if="i == 0" type="button" class="btn btn-sm btn-primary" style="width: 30px" @click="addSSD">+</button>
                      <button v-else-if="i > 0" type="button" class="btn btn-sm btn-primary" style="width: 30px" @click="deleteSSD(i)">-</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex align-items-center mt-2" v-if="storageType == 2 || storageType == 3">
              <div class="col-1 pl-0">
                <span class="field-label"> HDD </span>
              </div>
              <div class="col-11 pr-0" v-if="hddSku">
                <multiselect v-model="selectHDD" :options="hddSku" label="itemName" :allow-empty="false" :select-label="'Type'" :deselect-label="''" placeholder="Select Item" track-by="itemName"></multiselect>
              </div>
            </div>
            <div v-if="productType == 'CPU'">
              <div class="d-flex align-items-center mt-2" v-for="(data,i) in selectVga" :key="'vga-' + i+1">
                <div class="col-1 pl-0">
                  <span v-if="i == 0" class="field-label"> GPU </span>
                  <span v-else class="field-label"> GPU - {{i+1}} </span>
                </div>
                <div class="col-lg-11 pr-0">
                  <div class="container px-0">
                    <div class="d-flex">
                      <div class="w-100 pr-1" v-if="vgaSku">
                        <multiselect v-model="selectVga[i]" :options="vgaSku" label="itemName" :allow-empty="false" :select-label="'Type'" :deselect-label="''" placeholder="Select Item" track-by="itemName"></multiselect>
                      </div>
                      <button v-if="i == selectVga.length -1" type="button" class="btn btn-sm btn-primary" style="width: 30px" @click="addVga">+</button>
                      <button v-else-if="i < selectVga.length -1" type="button" class="btn btn-sm btn-primary" style="width: 30px" @click="deleteVga(i)">-</button>
                    </div>
                  </div>
                </div>
              </div>
            </div> 
            <div class="d-flex align-items-center justify-content-end mt-4">
              <div class="col-1 px-0 mr-2">
                <button class="btn btn-danger btn-sm w-100" @click="toPage('/catalog/bom/' + $route.params.id + '?unit=' + isUnit)">Cancel</button>
              </div>
              <div class="col-1 px-0">
                <button v-if="!loadingSendBomData" class="btn btn-primary btn-sm w-100" @click="addBom">Save</button>
                <button v-else class="btn btn-primary btn-sm w-100" disabled><img src="~@/assets/images/2.gif" style="height: 18px; margin-right: 1px;" />Saving</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import SideBar from "../SideBar"
import CONSTANT from "../constPlugin";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
export default {
  name: 'CatalogBomAdd',
  components: {
    SideBar,
    Multiselect
  },
  data() {
    return {
      id: '',
      productName: '',
      productType: '',
      productTitle: '',
      productDetail: '',
      bomType: 1,
      casing: '',
      motherboard: '',
      processor: '',
      ram: [''],
      storage: '',
      vga: [{ name: '' }],
      isUnit: true,
      storageType: 1,
      ssdSku: [],
      hddSku: [],
      ramSku: [],
      processorSku: [],
      motherboardSku: [],
      caseSku: [],
      vgaSku: [],
      selectCase: { itemCode: '', itemName: 'Select Part' },
      selectMotherboard: { itemCode: '', itemName: 'Select Part' },
      selectProcessor: { itemCode: '', itemName: 'Select Part' },
      selectRam: [{ itemCode: '', itemName: 'Select Part' }],
      selectSSD: [{ itemCode: '', itemName: 'Select Part' }],
      selectHDD: { itemCode: '', itemName: 'Select Part' },
      selectVga: [{ itemCode: '', itemName: 'Select Part' }],
      unitBom: [],
      disableBody: false,
      loadingSendBomData: false,

      // Onboard Case
      onboardRamSize: null,
      onboardSSDSize: null
    }
  },
  computed: {
    validateRAMField() {
      if(this.onboardRamSize === null) {
        return true
      }
      if (this.productType === 'CPU' && this.selectMotherboard.ramOnboardCapacity < this.onboardRamSize) {
        return true
      }
      if(this.productType === 'Laptop' && this.selectProcessor.ramOnboardCapacity < this.onboardRamSize) {
        return true
      }
      return false
    },
    validateSSDField() {
      if(this.storageType == 1 || this.storageType == 3) {
        if(this.onboardSSDSize === null) {
          return true
        }
        if (this.productType === 'CPU' && this.selectMotherboard.storageOnboardCapacity < this.onboardSSDSize) {
          return true
        }
        if(this.productType === 'Laptop' && this.selectProcessor.storageOnboardCapacity < this.onboardSSDSize) {
          return true
        }
      }
      return false
    }
  },
  methods: {
    handleChangeProcessor(val) {
      if (this.onboardRamSize !== null) {
        this.selectRam = [{ itemCode: '', itemName: 'Select Part' }]
      }
      if (this.onboardSSDSize !== null) {
        this.selectSSD = [{ itemCode: '', itemName: 'Select Part' }]
      }
    },
    getItem() {
      this.$http.post(process.env.GET_CATALOG_EDIT, {
          catalogId: Number(this.id),
          isUnit: this.isUnit,
        }, {
          headers: {
            "Asani-Token": localStorage.getItem("jwt"),
          },
        })
        .then(async (res) => {
          let data = res.data.content
          this.isOnboard = data.costumeOnboardRam || data.costumeOnboardStorage
          this.productName = data.name
          if(data.costumeOnboardRam) {
            const parseRamSize = Number(data.productDetail.ram)
            this.onboardRamSize = isNaN(parseRamSize) ? 0 : parseRamSize
          }

          if(data.costumeOnboardStorage) {
            let tempSSDSize = 0
            data.productDetail.storage.split(",").forEach(el => {
              if(el.includes('SSD')) {
                tempSSDSize = Number(el.split(' ')[0].replace('GB', ''))
              }
            })
            this.onboardSSDSize = isNaN(tempSSDSize) ? 0 : tempSSDSize
          }

          let type = ''
          CONSTANT.PRODUCT_TYPE.forEach(el => {
            if (el.status == data.productType) {
              type = el.statusName
            }
          })
          this.productTitle = `${type} - ${data.name} ${data.productDetail.processor} / ${data.productDetail.ram} GB / ${data.productDetail.storage} / ${data.productDetail.vga}`
          this.productDetail = data.productDetail
          this.productType = type
          if (type == 'Laptop') {
            this.getPart('body')
          } else if (type == 'CPU') {
            this.getPart('case CPU')
            this.getPart('motherboard')
            this.getPart('processor')
            this.getPart('vga')
          }
          this.getPart('ram')
          if (data.productDetail.storage.includes('SSD')) {
            this.storageType = 1
            this.getPart('ssd')
            if (data.productDetail.storage.includes('HDD')) {
              this.storageType = 3
              this.getPart('ssd')
              this.getPart('hdd')
            }
          } else if (data.productDetail.storage.includes('HDD')) {
            this.storageType = 2
            this.getPart('hdd')
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    getPart(type) {
      let queryParams = ""
      if(type === 'motherboard' || type === 'body') {
        queryParams += "?itemName=" + this.productName
        queryParams += "&isOnboard=" + this.isOnboard
      }
      this.$http.get(process.env.GET_SPAREPART_BOM + type + queryParams, {
          headers: {
            "Asani-Token": localStorage.getItem("jwt"),
          },
        })
        .then(res => {
          if (type == 'case CPU') {
            this.getUnitBom()
            this.caseSku = res.data.content
          } else if (type == 'motherboard') {
            this.motherboardSku = res.data.content
          } else if (type == 'body') {
            this.getUnitBom()
            this.processorSku = res.data.content
          } else if (type == 'processor') {
            this.getUnitBom()
            this.processorSku = res.data.content
          } else if (type == 'ram') {
            this.ramSku = res.data.content || []
          } else if (type == 'vga') {
            this.vgaSku = res.data.content
          } else if (type == 'hdd') {
            this.hddSku = res.data.content
          } else if (type == 'ssd') {
            this.ssdSku = res.data.content || []
          }
        })
        .catch(error => {
          swal("Sorry", error.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    getUnitBom() {
      this.$http.get(process.env.GET_CATALOG_BOM + this.$route.params.id, {
          headers: {
            "Asani-Token": localStorage.getItem("jwt"),
          }
        })
        .then(res => {
          if (res.status == 200) {
            this.unitBom = res.data.content
            if(this.unitBom && this.unitBom.length) {
              this.unitBom.forEach(item => {
                item.itemBom.forEach(el => {
                  if(el.itemGroup == 'Body' || el.itemGroup == 'Processor') {
                    if(this.processorSku && this.processorSku.length > 0) {
                      this.selectProcessor = this.processorSku.find(val => val.itemCode == el.itemCode)
                    }
                    if(this.selectProcessor) {
                       this.disableBody = true
                    }
                   
                  }
                })
              })
              
            }
          }
          console.log()
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    checkRamAndSSD() {
      // Check if ram is onboard or removeable, if ram onboard check if the capacity is enough
        if (this.validateRAMField) {
          if (this.selectRam.length < 1) {
            swal('Error', 'Mohon lengkapi data RAM', 'error')
            return false
          }
          if (this.selectRam.findIndex(el => el.itemCode == '') > -1) {
            swal('Error', 'Mohon lengkapi data RAM', 'error')
            return false
          }
        }
        // Check if ssd is onboard or removeable, if ssd onboard check if the capacity is enough
        if (this.validateSSDField) {
          if(this.storageType == 1) {
            if(this.selectSSD.length < 1) {
              swal('Error', 'Mohon lengkapi data SSD', 'error')
              return false
            }
          }

          if( this.storageType == 3) {
            if(this.selectSSD.length < 1 || !this.selectHDD.itemCode) {
              swal('Error', 'Mohon lengkapi data SSD dan HDD', 'error')
              return false
            }
          }
        }

        if(this.storageType == 2 && !this.selectHDD.itemCode) {
          swal('Error', 'Mohon lengkapi data HDD', 'error')
          return false
        }

        return true
    },
    addBom() {
      if(this.productType == 'Laptop') {
        if(!this.selectProcessor.itemCode) {
          return swal('Error', 'Mohon lengkapi data body', 'error')
        }
        
        if(!this.checkRamAndSSD()) return;
        // if(!this.selectProcessor.itemCode || this.selectRam.length < 1 || !this.selectSSD.itemCode) {
        //   return swal('Error', 'Mohon lengkapi data.', 'error')
        // }
      } else if (this.productType == 'CPU'){
        if(!this.selectCase.itemCode || !this.selectMotherboard.itemCode ||!this.selectProcessor.itemCode) {
          return swal('Error', 'Mohon lengkapi data.', 'error')
        }
        
        if(!this.checkRamAndSSD()) return;
        
        //if (this.selectVga.findIndex(el => el.itemCode == '') > -1) {
         // return swal('Error', 'Mohon lengkapi data', 'error')
        //}
      }
      let datas = { case: this.selectCase, motherboard: this.motherboard, processor: this.selectProcessor, ram: this.selectRam, ssd: this.selectSSD, hdd: this.selectHDD, vga: this.selectVga }
      console.log(datas)
      let boms = []
      if(this.productType == 'Laptop') {
        boms.push(this.selectProcessor.itemCode)
        this.selectRam.forEach(el => {
          boms.push(el.itemCode)
        })
        if(this.storageType == 1) {
          this.selectSSD.forEach(el => {
            boms.push(el.itemCode)
          })
        } else if(this.storageType == 2) {
          boms.push(this.selectHDD.itemCode)
        } else if(this.storageType == 3) {
          this.selectSSD.forEach(el => {
            boms.push(el.itemCode)
          })
          boms.push(this.selectHDD.itemCode)
        }
        // this.selectVga.forEach(el => {
        //   boms.push(el.itemCode)
        // })
      } else if (this.productType == 'CPU') {
        if(this.selectCase.itemCode) {
          boms.push(this.selectCase.itemCode)
        }
        if(this.selectMotherboard.itemCode) {
          boms.push(this.selectMotherboard.itemCode)
        }
        boms.push(this.selectProcessor.itemCode)
        this.selectRam.forEach(el => {
          boms.push(el.itemCode)
        })
        if(this.storageType == 1) {
          this.selectSSD.forEach(el => {
            boms.push(el.itemCode)
          })
        } else if(this.storageType == 2) {
          boms.push(this.selectHDD.itemCode)
        } else if(this.storageType == 3) {
          this.selectSSD.forEach(el => {
            boms.push(el.itemCode)
          })
          boms.push(this.selectHDD.itemCode)
        }
        if(this.selectVga.length > 0) {
          this.selectVga.forEach(el => {
            boms.push(el.itemCode)
          })
        }
      }
      this. loadingSendBomData = true
      this.$http.post(process.env.ADD_CATALOG_BOM, {
        itemCode: this.id,
        itemBom: boms.filter(el => el),
      },
      {
        headers: {
            "Asani-Token": localStorage.getItem("jwt"),
          },
      })
      .then(res => {
        this.loadingSendBomData = false
        console.log(res)
        if(res.data.status == 200) {
          swal("Success", 'Success Add BOM', "success", {
              button: "Ok",
          }).then((value) => {
            this.toPage('/catalog/bom/' + this.id + '?unit=' + this.isUnit)
          })
        } else {
          swal('Gagal', res.data.message, 'error')
        }
      })
      .catch(error => {
        this.loadingSendBomData = false
        swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
      })
    },
    sidebar() {
      $("#wrapper").toggleClass("toggled");
    },
    addRam() {
      this.selectRam.push({ itemCode: '', itemName: 'Select Part' })
    },
    addSSD() {
      this.selectSSD.push({ itemCode: '', itemName: 'Select Part' })
    },
    addVga() {
      this.selectVga.push({ itemCode: '', itemName: 'Select Part' })
    },
    deleteRam(i) {
      let newSelect = []
      for(let x = 0;x < this.selectRam.length; x++) {
        if(x != i) {
          newSelect.push(this.selectRam[x])
        }
      }
      this.selectRam = newSelect
    },
    deleteSSD(i) {
      let newSelect = []
      for(let x = 0;x < this.selectSSD.length; x++) {
        if(x != i) {
          newSelect.push(this.selectSSD[x])
        }
      }
      this.selectSSD = newSelect
    },
    deleteVga(i) {
      
      let newSelect = []
      for(let x = 0;x < this.selectVga.length; x++) {
        if(x != i) {
          newSelect.push(this.selectVga[x])
        }
      }
      this.selectVga = newSelect
    },
    toPage(e) {
      this.$router.push(e)
    },
    cekPermission() {
      this.permission = localStorage.getItem("roles").replace(/"/g, "").replace("[", "").replace("]", "").split(",");
      for (var i = 0; i < this.permission.length; i++) {
        if (this.permission[i] == "1") {
          this.viewDashboard = true;
        }
        if (this.permission[i] == "2.1") {
          this.viewOrder = true;
        }
        if (this.permission[i] == "2.2") {
          this.editOrder = true;
        }
        if (this.permission[i] == "3.1") {
          this.viewReturn = true;
        }
        if (this.permission[i] == "3.2") {
          this.editReturn = true;
        }
        if (this.permission[i] == "4.1") {
          this.viewProduct = true;
        }
        if (this.permission[i] == "4.2") {
          this.editProduct = true;
        }
        if (this.permission[i] == "5.1") {
          this.viewPairing = true;
        }
        if (this.permission[i] == "5.2") {
          this.editPairing = true;
        }
        if (this.permission[i] == "6") {
          this.viewReconcile = true;
        }
        if (this.permission[i] == "7.1") {
          this.viewResolution = true;
        }
        if (this.permission[i] == "7.2") {
          this.editResolution = true;
        }
        if (this.permission[i] == "8.1") {
          this.viewLessor = true;
        }
        if (this.permission[i] == "8.2") {
          this.editLessor = true;
        }
        if (this.permission[i] == "9.1") {
          this.viewLessee = true;
        }
        if (this.permission[i] == "9.2") {
          this.editLessee = true;
        }
        if (this.permission[i] == "10") {
          this.viewEmployee = true;
        }
      }
      if (this.editProduct == false) {
        this.$router.push("/");
      }
    },
    cekLogin() {
      if (localStorage.getItem("jwt") == null) {
        this.$router.push("/");
      }
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem("jwt");
      localStorage.removeItem("admin_name");
      localStorage.removeItem("roles");
      localStorage.removeItem("user_email");
      localStorage.removeItem("admin_id");
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push("/");
    },
  },
  created() {
    this.admin = localStorage.getItem("admin_name");
    this.adminId = localStorage.getItem("admin_id");
    this.id = this.$route.params.id
    this.isUnit = Boolean(this.$route.query.unit);
    this.cekLogin();
    this.cekPermission();
    this.getItem()
    // this.getUnitBom()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Catalog/CatalogAddBomPage.vue